<template>
	<div>
		<div class="card">
			<div class="card-body">
				<div class="row">
					<div class="col-md-6">
						<b-form @submit="onSubmitForm">
							<b-alert :show="showAlertError" variant="danger">
								<ul>
									<li v-for="(error, key) in errors" :key="key">{{ error }}</li>
								</ul>
							</b-alert>

							<b-form-group horizontal label="Шаблон письма" :class="{ 'has-error': $v.form.email.$error }" label-for="email" class="is-required">
								<ckeditor id="email" :editor="editor" rows="7" v-model.trim="form.email" :config="editorConfig"></ckeditor>
							</b-form-group>
						</b-form>
					</div>
				</div>
			</div>
			<div class="card-footer">
				<div class="float-left">
					<b-button variant="primary" @click="onSubmitForm">Сохранить изменения</b-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import productHTTP from '@/api/modules/product/product'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
export default {
	data () {
		return {
			showAlertError: false,
			form: {
				email: ''
			},
			errors: {},
			editor: ClassicEditor,
			editorConfig: {
				properties: {
					rows: 7
				},
				toolbar: {
					items: [
						'bold',
						'italic',
						'bulletedList',
						'numberedList',
						'blockQuote',
						'link',
						'undo',
						'redo'
					]
				}
			},
			editorData: '<p>Content of the editor.</p>'
		}
	},
	props: {
		id: {
			type: Number,
			required: true
		}
	},
	validations: {
		form: {
			email: {
				required
			}
		}
	},
	created () {
		this.getEvent()
	},
	methods: {
		getEvent () {
			productHTTP.findOne(this.id).then((product) => {
				this.form.email = product.email !== null ? product.email : ''
			})
		},
		onSubmitForm (e) {
			e.preventDefault()
			this.$v.$touch()
			if (this.$v.$invalid) return false

			const data = {
				email: this.form.email
			}
			productHTTP.update(this.id, data).then((response) => {
				this.$notify({
					group: 'default',
					type: 'success',
					'title': 'Поздравляем!',
					text: 'Данные успешно обновлены.'
				})
			}, (response) => {
				this.$notify({
					group: 'default',
					type: 'danger',
					text: response
				})
			})
		}
	}
}
</script>
<style>
.ck.ck-editor__editable, .ck.ck-focused {
	min-height: 200px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/online/update/email.vue